module.exports = __webpack_public_path__ + "img/aboutme.38fbb415.jpg";